import {
  Companion_getInstance1gfb55agtbi7k as Companion_getInstance,
  UpdateRestrictions6ebv9x6ps9p5 as UpdateRestrictions,
} from './UpdateRestrictions.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../serialization/SerializableProperty.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareUpdateRestrictionsFields() {
  var tmp = Companion_getInstance().d2j(NothingSerializer());
  properties(tmp, prepareUpdateRestrictionsFields$lambda);
}
function UpdateRestrictions_fields$name$delegate$lambda() {
  return Companion_getInstance().d2j(NothingSerializer()).az().v11(0);
}
function UpdateRestrictions_fields$_get_name_$ref_rwdnn9() {
  return (p0) => p0.k20();
}
function UpdateRestrictions_fields$_get_serializer_$ref_20q3x8() {
  return (p0) => p0.j2j();
}
function UpdateRestrictions_fields$_get_annotations_$ref_7p2e5c() {
  return (p0) => p0.bz();
}
var UpdateRestrictions_fieldsClass;
function UpdateRestrictions_fields() {
  if (UpdateRestrictions_fieldsClass === VOID) {
    class $ {
      constructor(t) {
        var tmp = this;
        tmp.q2l_1 = lazy(UpdateRestrictions_fields$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r2l_1 = lazy(() => {
          var tmp = Companion_getInstance().d2j(t);
          var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
          return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        });
        var tmp_1 = this;
        tmp_1.s2l_1 = lazy(() => Companion_getInstance().d2j(t).az().x11(0));
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.t2l_1 = emptyList();
        this.u2l_1 = 'listOf()';
      }
      k20() {
        var tmp0 = this.q2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, UpdateRestrictions_fields$_get_name_$ref_rwdnn9(), null);
        return tmp0.f2();
      }
      v2l(receiver) {
        return receiver.w2l_1;
      }
      m2j(receiver) {
        return this.v2l(receiver instanceof UpdateRestrictions() ? receiver : THROW_CCE());
      }
      x2l(receiver, value) {
        return receiver.y2l(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof UpdateRestrictions() ? receiver : THROW_CCE();
        return this.x2l(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, UpdateRestrictions_fields$_get_serializer_$ref_20q3x8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s2l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, UpdateRestrictions_fields$_get_annotations_$ref_7p2e5c(), null);
        return tmp0.f2();
      }
      hashCode() {
        return -1139531241;
      }
      equals(other) {
        return other instanceof UpdateRestrictions_fields();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForClass($, 'UpdateRestrictions_fields', VOID, VOID, [SerializableProperty()]);
    UpdateRestrictions_fieldsClass = $;
  }
  return UpdateRestrictions_fieldsClass;
}
function prepareUpdateRestrictionsFields$lambda(args) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new (UpdateRestrictions_fields())(args[0])];
}
//region block: exports
export {
  prepareUpdateRestrictionsFields as prepareUpdateRestrictionsFieldsqqn8zo8u2pcf,
};
//endregion

//# sourceMappingURL=UpdateRestrictionsFields.mjs.map
